import React, { useState, useEffect, useMemo, useCallback } from "react";
import Topbar from "../../components/Topbar/Topbar";
import {
  MenuItem,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DateRange from "../../components/DateRange/DateRange";
import { Table } from "../../components/Table/Table";
import moment from "moment";
import { checkPermission } from "../redux/api/PermissionManager";
import { useLocation, useNavigate } from "react-router-dom";
import { edit_icon } from "../../assets/img";
import { get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { toast } from "react-toastify";

const PAGE_SIZE = 10;

const TABS = {
  CHAT_AI: "Chat AI",
  BOOKING_AI: "Booking AI",
};

const READ_STATUS = {
  UNREAD: "UnRead",
  READ: "Read",
};

const RATING_OPTIONS = [
  { value: 1, label: "Good" },
  { value: 0, label: "Bad" },
];

function AISupport() {
  const navigate = useNavigate();
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");

  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  const [headerActive, setHeaderActive] = useState(
    paginationData?.[path]?.headerActive ?? TABS.CHAT_AI,
  );
  const [isActiveTab, setIsActiveTab] = useState(
    paginationData?.[path]?.isActiveTab ?? READ_STATUS.UNREAD,
  );
  const [selectedProperty, setSelectedProperty] = useState("");
  const [isCount, setIsCount] = useState("");
  const [selectedDate, setSelectedDate] = useState({ from: "", to: "" });
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [openRemarkModal, setOpenRemarkModal] = useState(false);
  const [remarkText, setRemarkText] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  console.log("====================================");
  console.log("paginationDatapaginationData", paginationData);
  console.log("====================================");
  const fetchList = useCallback(
    async (pageNo = page) => {
      const hasFromDate = !!selectedDate?.from;
      const hasToDate = !!selectedDate?.to;
      if (hasFromDate !== hasToDate) {
        return;
      }

      setLoading(true);
      try {
        const url = URLS.CHAT_AI_LIST;

        const params = {
          page: pageNo,
          status: isActiveTab === READ_STATUS.READ ? 2 : 1,
          review_ai: headerActive === TABS.CHAT_AI ? 0 : 1,
        };

        if (selectedProperty !== "" && selectedProperty != null) {
          params.type = selectedProperty;
        }

        if (hasFromDate && hasToDate) {
          params.from_date = selectedDate.from;
          params.to_date = selectedDate.to;
        }

        const queryString = new URLSearchParams(
          Object.entries(params).filter(
            ([, v]) => v !== "" && v !== null && v !== undefined,
          ),
        ).toString();

        const res = await get(`${url}?${queryString}`);
        console.log("res.datares.datares.data", res?.count);
        if (res?.data) {
          setTableData(res.data ?? []);
          setPagination({
            current_page: pageNo,
            last_page: res?.total_pages,
          });
          setIsCount(res?.count);
        }
      } catch (err) {
        console.error("Failed to fetch AI support list:", err);
        toast.error("Unable to load data. Please try again.");
      } finally {
        setLoading(false);
      }
    },
    [page, headerActive, isActiveTab, selectedProperty, selectedDate],
  );

  useEffect(() => {
    fetchList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page, isActiveTab, headerActive },
    }));
  }, [page, isActiveTab, headerActive]);

  useEffect(() => {
    if (page !== 1) {
      setPage(1);
    } else {
      fetchList(1);
    }
  }, [headerActive, isActiveTab, selectedProperty, selectedDate]);

  const closeRemarkModal = useCallback(() => {
    setOpenRemarkModal(false);
    setSelectedRow(null);
    setRemarkText("");
  }, []);

  const handleRemarkClick = useCallback((row) => {
    setSelectedRow(row);
    setRemarkText("");
    setOpenRemarkModal(true);
  }, []);

  const updateRemark = useCallback(
    async (item, payload, successMessage) => {
      if (!item?.id) return;

      setSubmitting(true);
      try {
        const res = await put(
          `${URLS.CHAT_AI_LIST_UPDATE}${item.id}/`,
          payload,
        );

        if (res?.status === "success") {
          if (successMessage) {
            toast.success(res?.message || successMessage);
          }
          closeRemarkModal();
          fetchList(page);
        } else {
          toast.error(
            res?.message || "Something went wrong. Please try again.",
          );
        }
      } catch (err) {
        console.error("Failed to update remark:", err);
        toast.error("Unable to save your changes. Please try again.");
      } finally {
        setSubmitting(false);
      }
    },
    [closeRemarkModal, fetchList, page],
  );

  const handleSkip = useCallback(
    (item) => updateRemark(item, { remark: remarkText }),
    [updateRemark, remarkText],
  );

  const handleSubmitRemark = useCallback(
    (item) =>
      updateRemark(item, { notes: remarkText }, "Remark saved successfully"),
    [updateRemark, remarkText],
  );

  const chatAIColumns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "s_no",
        Cell: ({ row }) => <p>{row.index + 1 + (page - 1) * PAGE_SIZE}</p>,
      },
      {
        Header: "User Name",
        accessor: "user",
        Cell: ({ value, row }) => (
          <p className="text-nowrap">
            {value || "-"}&nbsp;
            <span style={{ color: "#adadad", fontSize: 12 }}>
              ({row?.original?.user_code})
            </span>
          </p>
        ),
      },
      {
        Header: "Type",
        accessor: "rating",
        Cell: ({ value }) => (
          <p className="text-nowrap">
            {value == null ? "-" : value !== 1 ? "Good" : "Bad"}
          </p>
        ),
      },
      {
        Header: "User Query",
        accessor: "feedback_message",
        Cell: ({ value, row }) => {
          const { rating } = row?.original ?? {};
          const content = !rating
            ? "-"
            : rating == 1
              ? value
              : `${rating} Rate`;
          return (
            <p className="text-truncate" style={{ maxWidth: 250 }}>
              {content || "-"}
            </p>
          );
        },
      },
      {
        Header: "Raised Date/Time",
        accessor: "created_at",
        Cell: ({ value }) => (
          <p className="text-truncate" style={{ maxWidth: 250 }}>
            {value ? moment.utc(value).format("DD MMM YYYY, hh:mm A") : "-"}
          </p>
        ),
      },
      {
        Header: `${isActiveTab !== READ_STATUS.READ ? "Marked Read" : "Comments"}`,
        accessor: "action",
        Cell: ({ row }) => {
          if (isActiveTab === READ_STATUS.READ) {
            return (
              <p
                style={{
                  maxWidth: 250,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {row?.original?.admin_notes || "-"}
              </p>
            );
          }
          return (
            <div className="d-flex ac-js">
              <button
                onClick={() => handleRemarkClick(row.original)}
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14"
                style={{ background: "#9a36e69c" }}
              >
                Remark
              </button>
            </div>
          );
        },
      },
    ],
    [page, isActiveTab, handleRemarkClick],
  );

  const bookingAIColumns = useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "s_no",
        Cell: ({ row }) => <p>{row.index + 1 + (page - 1) * PAGE_SIZE}</p>,
      },
      {
        Header: "User Name",
        accessor: "user",
        Cell: ({ value, row }) => (
          <p className="text-nowrap">
            {value || "-"}&nbsp;
            <span style={{ color: "#adadad", fontSize: 12 }}>
              ({row?.original?.user_code})
            </span>
          </p>
        ),
      },
      {
        Header: "Booking ID",
        accessor: "booking_code",
        Cell: ({ value, row }) => (
          <p
            onClick={() => {
              // if (type !== "Refund" && checkPermission("CAN-VIEW-TRANSACTION"))
              navigate("/booking-list-view", {
                state: {
                  type: "edit",
                  booking_id: row.original?.booking_id,
                },
              });
            }}
            className="primary pointer"
          >
            {value || "-"}
            {/* 
            {row?.original?.booking_id && (
              <span style={{ color: "#adadad", fontSize: 12 }}>
                ({row?.original?.booking_id})
              </span>
            )} */}
          </p>
        ),
      },
      {
        Header: "Property",
        accessor: "property_name",
        Cell: ({ value, row }) => (
          <p className="text-nowrap">
            {value || "-"}&nbsp;
            {row?.original?.property_code && (
              <span style={{ color: "#adadad", fontSize: 12 }}>
                ({row?.original?.property_code})
              </span>
            )}
          </p>
        ),
      },
      {
        Header: "Query",
        accessor: "booking_feedback_message",
        Cell: ({ value, row }) => {
          const { booking_rating } = row?.original ?? {};
          const content = !booking_rating
            ? "-"
            : booking_rating == 1
              ? value
              : `${booking_rating} Rate`;
          return (
            <p className="text-truncate" style={{ maxWidth: 250 }}>
              {content || "-"}
            </p>
          );
        },
      },
      {
        Header: "Date",
        accessor: "created_at",
        Cell: ({ value }) => (
          <p className="text-nowrap">
            {value ? moment(value).format("DD/MM/YYYY hh:mm A") : "-"}
          </p>
        ),
      },
      // {
      //   Header: "Status",
      //   accessor: "status",
      //   Cell: ({ value }) => (
      //     <p className={value == 1 ? "text-success" : "text-danger"}>
      //       {value == 1 ? "Read" : "UnRead"}
      //     </p>
      //   ),
      // },
      {
        Header: `${isActiveTab !== READ_STATUS.READ ? "Marked Read" : "Comments"}`,
        accessor: "action",
        Cell: ({ row }) => {
          console.log("====================================");
          console.log(
            ":isActiveTabisActiveTabisActiveTab",
            isActiveTab,
            READ_STATUS.READ,
            READ_STATUS,
            isActiveTab === READ_STATUS.READ,
          );
          console.log("====================================");
          if (isActiveTab === READ_STATUS.READ) {
            return (
              <p
                style={{
                  maxWidth: 250,
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {row?.original?.admin_notes || "-"}
              </p>
            );
          }
          return (
            <div className="d-flex ac-js">
              <button
                onClick={() => handleRemarkClick(row.original)}
                className="submit-btn f2 fs-sm-10 fs-md-10 fs-lg-10 fs-xl-12 fs-xxl-14"
                style={{ background: "#9a36e69c" }}
              >
                Remark
              </button>
            </div>
          );
        },
      },
    ],
    [page, navigate, isActiveTab],
  );

  const columnsMap = {
    [TABS.CHAT_AI]: chatAIColumns,
    [TABS.BOOKING_AI]: bookingAIColumns,
  };

  const activeColumns = columnsMap[headerActive] ?? [];

  return (
    <div>
      <Topbar header="AI Review" subHead="Rating and Reviews" />

      <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
        {Object.values(TABS).map((tab) => (
          <div
            key={tab}
            role="button"
            tabIndex={0}
            style={{
              background: headerActive === tab ? "#78788029" : "",
              width: "40%",
              textAlign: "center",
              padding: "10px 20px",
              borderRadius: 8,
              cursor: "pointer",
            }}
            onClick={() => setHeaderActive(tab)}
          >
            <p>{tab}</p>
          </div>
        ))}
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 20,
        }}
      >
        <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
          {Object.values(READ_STATUS).map((status) => (
            <div
              key={status}
              role="button"
              tabIndex={0}
              style={{
                background: isActiveTab === status ? "#AE55F5" : "#78788029",
                textAlign: "center",
                padding: "10px 20px",
                borderRadius: 8,
                cursor: "pointer",
              }}
              onClick={() => setIsActiveTab(status)}
            >
              <p style={{ color: isActiveTab === status ? "#fff" : "#000" }}>
                {status}
              </p>
            </div>
          ))}
        </div>

        <div className="d-flex gap-2 ac-jb">
          <Select
            className="location-search"
            displayEmpty
            value={selectedProperty}
            onChange={(e) => setSelectedProperty(e.target.value)}
            renderValue={(selected) => {
              if (selected === "" || selected == null) {
                return <span style={{ color: "#999" }}>All</span>;
              }
              const found = RATING_OPTIONS.find((o) => o.value === selected);
              return found?.label || "";
            }}
            sx={{ minWidth: 160 }}
          >
            <MenuItem value="">
              <em>All</em>
            </MenuItem>
            {RATING_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </Select>
          <DateRange
            setFromDate={(from) =>
              setSelectedDate((prev) => ({ ...prev, from }))
            }
            setToDate={(to) => setSelectedDate((prev) => ({ ...prev, to }))}
          />
        </div>
      </div>
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{isCount}
      </h2>
      {/* <p>Total:{isCount}</p> */}
      <Table
        columns={activeColumns}
        setPageno={setPage}
        pagecount={pagination}
        data={tableData}
        show
        loading={loading}
      />

      <Dialog
        open={openRemarkModal}
        onClose={closeRemarkModal}
        fullWidth
        maxWidth="sm"
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <DialogTitle>Add Remark</DialogTitle>
          <IconButton onClick={closeRemarkModal} size="small" sx={{ mr: 1 }}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </div>

        <DialogContent>
          <TextField
            autoFocus
            multiline
            minRows={4}
            fullWidth
            placeholder="Enter your remark..."
            value={remarkText}
            onChange={(e) => setRemarkText(e.target.value)}
            sx={{ mt: 1 }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleSkip(selectedRow)} disabled={submitting}>
            Skip
          </Button>
          <Button
            onClick={() => handleSubmitRemark(selectedRow)}
            variant="contained"
            disabled={submitting || !remarkText.trim()}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AISupport;
